import React from 'react';
import KaraokeRegistrationCancelFormView1 from './KaraokeRegistrationCancelFormView1';
import KaraokeRegistrationCancelFormView2 from './KaraokeRegistrationCancelFormView2';
import { KaraokeModificationClientContext } from '../../context/KaraokeModificationClientContext';
import { showErrorFlush } from '../../../common/form/FrekulForm';

type KaraokeRegistrationCancelFormViewName = 'view1'|'view2';
type KaraokeRegistrationCancelFormAjaxName = 'execute';

export default function KaraokeRegistrationCancelForm({
  karaokeOrderId,
  isBeforePayment,
  paymentAmount,
  shouldRefundOnCancellation,
  isAvailableOnNextone,
} : {
  karaokeOrderId: number,
  isBeforePayment: boolean,
  paymentAmount: number,
  shouldRefundOnCancellation: boolean,
  isAvailableOnNextone: boolean,
}) {
  const [view, setView] = React.useState<KaraokeRegistrationCancelFormViewName>('view1');
  const [ajax, setAjax] = React.useState<KaraokeRegistrationCancelFormAjaxName|null>(null);

  const { executeKaraokeRegistrationCancel } = React.useContext(KaraokeModificationClientContext);

  React.useEffect(() => {
    if (ajax === 'execute') {
      executeKaraokeRegistrationCancel(karaokeOrderId).then((responseData) => {
        setAjax(null);
        if (responseData.result) {
          setView('view2');
        } else {
          showErrorFlush('入力内容に不備があります。');
        }
      });
    }
  }, [ajax]);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  return (
    <>
      {view === 'view1' && (
        <KaraokeRegistrationCancelFormView1
          isBeforePayment={isBeforePayment}
          paymentAmount={paymentAmount}
          shouldRefundOnCancellation={shouldRefundOnCancellation}
          isAvailableOnNextone={isAvailableOnNextone}
          onNext={() => setAjax('execute')}
        />
      )}
      {view === 'view2' && (
        <KaraokeRegistrationCancelFormView2
          isBeforePayment={isBeforePayment}
          paymentAmount={paymentAmount}
          isAvailableOnNextone={isAvailableOnNextone}
          onBackToHome={() => handleBackToHome()}
        />
      )}
    </>
  );
}
